;(function ($) {
	let flags = $('.flags input:radio');

	/**
	 * Highlight current flag image.
	 *
	 * @returns void
	 */
	function highlightCurrent() {
		flags.siblings('.description').find('img').removeClass('checked');
		flags.filter(':checked').siblings('.description').find('img').addClass('checked');
	}

	flags.on('change', highlightCurrent);
	flags.trigger('change');
})(jQuery);

(function () {
	let forceSelect, $selector = $('[data-flag]');

	forceSelect = function (el, option) {
		el.find('#flag_'+option).trigger('click');
	};

	$selector.on('keydown', function () {
		let val = $(this).val().replace(/\D/g, '').substring(0, 6);
		let creditCardType = require('credit-card-type');
		let result = creditCardType(val);
		let target = $($(this).data('flag'));

		if (result.length === 1) {
			if (result[0].type === 'american-express') {
				return forceSelect(target, 'american_express');
			} else if (result[0].type === 'diners-club') {
				return forceSelect(target, 'diners_club');
			} else if (result[0].type === 'visa') {
				return forceSelect(target, 'visa');
			} else if (result[0].type === 'master-card') {
				return forceSelect(target, 'mastercard');
			}
		}
	});

})();
